import { useEffect, useState } from "react";
import axiosInstance from "../api/axiosInstance";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  TextField,
  Stack,
  Radio,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  RadioGroup,
} from "@mui/material";
import ChecklistIcon from "@mui/icons-material/Checklist";

export default function AssignProviderModal({
  order,
  open,
  onClose,
  onSelectProvider,
}) {
  const [sameAreaProviders, setSameAreaProviders] = useState([]);
  const [otherAreaProviders, setOtherAreaProviders] = useState([]);
  const [selectedProvider, setSelectedProvider] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (open && order?.id) {
      setLoading(true);
      axiosInstance
        .get(`orders/${order.id}/eligible-providers/`)
        .then((res) => {
          setSameAreaProviders(res.data.same_area || []);
          setOtherAreaProviders(res.data.other_areas || []);
        })
        .catch((err) => {
          console.error("Failed to fetch eligible providers", err);
        })
        .finally(() => setLoading(false));
    }
  }, [open, order?.id]);
  const handleSelect = (event) => {
    const id = event.target.value;
    const allProviders = [...sameAreaProviders, ...otherAreaProviders];
    const provider = allProviders.find((p) => p.id == id);

    setSelectedProvider(provider);
  };

  const handleConfirm = () => {
    if (selectedProvider) {
      onSelectProvider(selectedProvider);
      handleClose();
    }
  };

  const handleClose = () => {
    setSelectedProvider(null);
    setSearchTerm("");
    onClose();
  };

  const filterProviders = (list) =>
    list.filter((p) =>
      p.name?.toLowerCase().includes(searchTerm.toLowerCase())
    );

  const renderProviderTable = (providers, title) => {
    if (providers.length === 0) return null;

    const filtered = filterProviders(providers);

    return (
      <>
        <Typography variant="subtitle1" sx={{ mt: 2, mb: 1 }}>
          {title}
        </Typography>
        {filtered.length > 0 ? (
          <RadioGroup
            value={selectedProvider?.id || ""}
            onChange={handleSelect}
          >
            <TableContainer component={Paper} variant="outlined">
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>اختيار</TableCell>
                    <TableCell>الاسم</TableCell>
                    <TableCell>رقم الهاتف</TableCell>
                    <TableCell>الموقع</TableCell>
                    <TableCell>التقييم</TableCell>
                    <TableCell>تاريخ الحجز القادم</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filtered.map((p) => (
                    <TableRow
                      key={p.id}
                      hover
                      selected={selectedProvider?.id === p.id}
                      sx={{ cursor: "pointer" }}
                      onClick={() => setSelectedProvider(p)}
                    >
                      <TableCell>
                        <Radio
                          value={p.id}
                          checked={selectedProvider?.id === p.id}
                        />
                      </TableCell>
                      <TableCell>{p.name}</TableCell>
                      <TableCell>{p.phone}</TableCell>
                      <TableCell>{p.location_name || "—"}</TableCell>{" "}
                      <TableCell>{p.rating ?? "—"}</TableCell>
                      <TableCell>
                        {p.next_available
                          ? new Date(p.next_available).toLocaleDateString()
                          : "—"}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </RadioGroup>
        ) : (
          <Typography color="text.secondary" sx={{ mt: 1 }}>
            لا يوجد مزودون مطابقون في هذه الفئة
          </Typography>
        )}
      </>
    );
  };

  return (
    <Dialog fullWidth open={open} maxWidth="md" onClose={handleClose} dir="rtl">
      <DialogTitle>
        <Stack direction="row" alignItems="center" spacing={1}>
          <ChecklistIcon />
          <Typography>اختر مزود الخدمة للطلب #{order?.id}</Typography>
        </Stack>
      </DialogTitle>

      <DialogContent>
        <TextField
          label="بحث عن مزود"
          variant="outlined"
          size="small"
          fullWidth
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          sx={{ mb: 2 }}
        />

        {loading ? (
          <Typography>جاري التحميل...</Typography>
        ) : (
          <>
            {renderProviderTable(sameAreaProviders, "مزودون في نفس المنطقة")}
            {renderProviderTable(otherAreaProviders, "مزودون من مناطق أخرى")}
          </>
        )}
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose}>إلغاء</Button>
        <Button
          variant="contained"
          disabled={!selectedProvider}
          onClick={handleConfirm}
        >
          تأكيد
        </Button>
      </DialogActions>
    </Dialog>
  );
}

// export default function AssignProviderModal({
//   order,
//   open,
//   onClose,
//   onSelectProvider,
// }) {
//   const [providers, setProviders] = useState([]);
//   const [selectedProvider, setSelectedProvider] = useState(null);
//   const [searchTerm, setSearchTerm] = useState("");

//   useEffect(() => {
//     if (open) {
//       axiosInstance
//         .get("users/providers/active/")
//         .then((res) => setProviders(res.data))
//         .catch((err) => console.error("Failed to fetch providers", err));
//     }
//   }, [open]);

//   const filteredProviders = providers.filter((p) =>
//     p.name?.toLowerCase().includes(searchTerm.toLowerCase())
//   );

//   const handleSelect = (event) => {
//     setSelectedProvider(event.target.value);
//   };

//   const handleConfirm = () => {
//     if (selectedProvider) {
//       onSelectProvider(selectedProvider);
//       setSelectedProvider(null);
//       setSearchTerm("");
//     }
//   };

//   const handleClose = () => {
//     setSelectedProvider(null);
//     setSearchTerm("");
//     onClose();
//   };

//   return (
//     <Dialog fullWidth open={open} maxWidth="sm" onClose={handleClose} dir="rtl">
//       <DialogTitle>
//         <Stack direction="row" alignItems="center" spacing={1}>
//           <ChecklistIcon />
//           <Typography>اختر مزود الخدمة للطلب المحدد #{order?.id}</Typography>
//         </Stack>
//       </DialogTitle>

//       <DialogContent>
//         <TextField
//           label="بحث عن مزود"
//           variant="outlined"
//           size="small"
//           fullWidth
//           value={searchTerm}
//           onChange={(e) => setSearchTerm(e.target.value)}
//           sx={{ mb: 2 }}
//         />

//         {filteredProviders.length > 0 ? (
//           <RadioGroup
//             value={selectedProvider || ""}
//             onChange={(e) => setSelectedProvider(e.target.value)}
//           >
//             <TableContainer component={Paper} variant="outlined">
//               <Table size="small">
//                 <TableHead>
//                   <TableRow>
//                     <TableCell>اختيار</TableCell>
//                     <TableCell>الاسم</TableCell>
//                     <TableCell>رقم الهاتف</TableCell>
//                   </TableRow>
//                 </TableHead>
//                 <TableBody>
//                   {filteredProviders.map((p) => (
//                     <TableRow
//                       key={p.provider.id}
//                       hover
//                       selected={selectedProvider === String(p.provider.id)}
//                       sx={{ cursor: "pointer" }}
//                       onClick={() => setSelectedProvider(String(p.provider.id))}
//                     >
//                       <TableCell>
//                         <Radio
//                           value={String(p.provider.id)}
//                           checked={selectedProvider === String(p.provider.id)}
//                         />
//                       </TableCell>
//                       <TableCell>{p.name}</TableCell>
//                       <TableCell>{p.phone}</TableCell>
//                     </TableRow>
//                   ))}
//                 </TableBody>
//               </Table>
//             </TableContainer>
//           </RadioGroup>
//         ) : (
//           <Typography color="text.secondary" sx={{ mt: 1 }}>
//             لا يوجد مزودون مطابقون
//           </Typography>
//         )}
//       </DialogContent>

//       <DialogActions>
//         <Button onClick={handleClose}>إلغاء</Button>
//         <Button
//           variant="contained"
//           disabled={!selectedProvider}
//           onClick={handleConfirm}
//         >
//           تأكيد
//         </Button>
//       </DialogActions>
//     </Dialog>
//   );
// }
